export default "__VITE_ASSET__DLSQJMxS__"